<template>
  <div>
    <headMeun
      v-model="headMeunId"
      :list="headMenuList"
    ></headMeun>
    <div class="contain">
      <leftMeun
        :list="leftMenuList"
        v-model="leftMeunId"
        class="left"
      ></leftMeun>

      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getGoodsList"
        class="right"
      >
        <goods :list="gList"></goods>
      </van-list>
    </div>
  </div>
</template>
<script>
import { headMeun, leftMeun, goods } from "./component";
import { getCategory, goodsList } from '@/api/goods'


async function getCateList (grade, id) {
  const result = await getCategory({
    grade: grade,
    parent_id: id || 0
  })
  try {

    if (result.data.data.status) {
      return result.data.data.cartList
    } else {
      return []
    }
  } catch (err) { }
}


export default {
  components: {
    headMeun,
    leftMeun,
    goods,
  },
  data () {
    return {
      headMeunId: 0,
      leftMeunId: 0,
      gList: [],
      headMenuList: [],
      leftMenuList: [],
      loading: false,
      finished: true,
      page: 0
    }
  },
  methods: {

    // 获取商品
    async getGoodsList () {
      let { headMeunId, leftMeunId } = this
      this.page++
      this.loading = true
      const result = await goodsList({
        page: this.page,
        size: 10,
        first_cat_id: headMeunId,
        second_cat_id: leftMeunId
      })
        this.loading = false
      try {
        const data = result.data.data
        
        if (data.goodsList.data.length !== 0) {
          this.gList = this.gList.concat(data.goodsList.data)
        } else {
          this.finished = true
        }
      } catch (err) {
        this.loading = false
        this.finished = true
      }
    },
    // 获取分类

    // 获取左分类列表
    async getLeftMenu () {
      // 选中的一级id
      const result = await getCateList(2, this.headMeunId)
      this.leftMenuList = result
      if (this.leftMenuList.length > 0) {
        this.leftMeunId = this.leftMenuList[0].cat_id
      } else {
        this.leftMeunId = ''
      }
    },
    // 获取头部分类列表
    async getHeadMenu () {
      const result = await getCateList(1, 0)
      this.headMenuList = result;
      this.headMeunId = this.headMenuList[0].cat_id
    },

  },
  watch: {
    headMeunId () {
      this.getLeftMenu()
    },
    leftMeunId (value) {
      this.page = 0;
      this.gList = []
      // 判断二级分类是否为空  为空则不请求
      this.finished = (value == '')
    }
  },
  created () {
    this.getHeadMenu()
  }
}
</script>
<style lang="scss" scoped>
.scorll-box {
  overflow-y: scroll;
  height: calc(100vh - env(safe-area-inset-bottom) - 4.1rem);
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.contain {
  display: flex;
  justify-content: space-between;

  .left {
    @extend .scorll-box;
  }

  .right {
    width: 67vw;
    background: #fff;
    @extend .scorll-box;
  }
}
</style>